export default __webpack_public_path__ + "b042d60e51e3d04175c5abccd8b6e152.png";